export default {
  name: 'auto-task-create',
  translationKey: 'auto-task-create-module',
  routePrefix: 'auto-task-create',
  routeNamePrefix: 'admin.auto-task-create',
  directRoutesAvailable: false,
}
